import { Component, input, output } from '@angular/core';
import { PortCallModel } from '../../../../shared/models/port-call.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-voyage-portcall-nav-current',
  imports: [TranslateModule],
  templateUrl: './voyage-portcall-nav-current.html',
})
export class VoyagePortcallNavCurrent {
  //Input y outputs
  currentPortCall = input<PortCallModel | null>(null);
  changePortcallAsActive = output<void>();

  //Events
  onChangePortCallAsActive(): void {
    if (this.currentPortCall() !== null) {
      this.changePortcallAsActive.emit();
    }
  }
}
